import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { userManualDownloadUrl } from '../utils/constants';
import Modal from "react-modal";
import StepHeader from '../screens/registration/stepHeader'

Modal.setAppElement("#root");


// {head,subHeader}
const Header = () => {

  const history = useNavigate();
  const [isLoading, setLoader] = useState(false);


  const loadScripts = () => {
    // This array contains all the files/CDNs 
    // const dynamicScripts = [
    //   'js/jquery.sticky.js',
    //   'js/metisMenu.min.js',
    //   'js/metisMenu-active.js',
    //   'js/main.js',
    //   'js/azia.js'
    // ];

    // for (let i = 0; i < dynamicScripts.length; i++) {
    //   const node = document.createElement('script');
    //   node.src = dynamicScripts[i];
    //   node.type = 'text/javascript';
    //   node.async = false;
    //   document.getElementsByTagName('head')[0].appendChild(node);
    // }
  }

  useEffect(() => {
    loadScripts();

  }, []);



  const onLogoutClick = () => {
    localStorage.clear();
    // history.push('/login');
  }

  const openPdf = () => {
    var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
    window.open(URL, null);
  }

  return (
    <>
      {isLoading ? (
        <Loader></Loader>
      ) : (
        null
      )}
      {/* app-Header */}
      <div className="app-header header sticky">
        <div className="app-header header sticky">
          <div className="container-fluid main-container">
            <div className="d-flex">
            <a className="logo-horizontal " href="index.html">
                <img
                  src="../images/itme.png" className="header-brand-img desktop-logo" alt="logo" />
              </a>
              <div class="side-header">
                <a class="header-brand1" >
                  <img src="../images/itme.png" class="header-brand-img header-brand-img-1 light-logo1" alt="top-left logo" />
                </a>
              </div>
              <p className="m-0 mt-2 header-logo-name">30<sup>th</sup> NOV - 02<sup>nd</sup> DEC 2023 <br></br> Kenyatta International Conventional Centre<br></br> Nairobi, Kenya
              </p>
              <p className="header-assistance">
                For Assistance
                <br>
                </br>
                +91 80108 23774 / +91 98205 07570
                <br>
                </br>
                <a href="mailto:itme@itme-africa.com">itme@itme-africa.com / </a>{" "}
                <a href="mailto:itme@india-itme.com"> itme@india-itme.com</a>
              </p>

              
              <div class="right-logo">
                <p className='right-logo-text'>Owned and Organised by</p>
                <img src="../images/itme-right-logo.png" className="header-brand-img desktop-logo" alt="logo" />
              </div>
            </div>
          </div>
        </div>
        {sessionStorage.getItem('completed') ? (null) : (<StepHeader />)}
        
      </div>
      {/* /app-Header */}
    </>
  );
}
export default Header;

